import { useMemo } from 'react';

import { useFetch } from '../../hooks';
import { getDistinctContactStates } from '../../api';
import { convertOptionsToMap } from '../../utilities';

const toLabel = (s: string) =>
  s.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

export const useCampaignStates = (
  campaignId?: string,
  initialStateOptions?: OptionType<LatestContactState>[]
) => {
  const { data: statesFromApi } = useFetch(
    () => getDistinctContactStates(campaignId),
    [campaignId],
    { skip: !!initialStateOptions }
  );

  const stateOptions = useMemo(() => {
    if (initialStateOptions) return initialStateOptions;

    const opts: OptionType<LatestContactState>[] = [
      { value: undefined, label: 'All Statuses' },
    ];

    statesFromApi?.forEach(s => opts.push({ value: s, label: toLabel(s) }));
    opts.push({ value: 'null', label: 'No State' });

    return opts;
  }, [initialStateOptions, statesFromApi]);

  const statesMap = useMemo(() => {
    return convertOptionsToMap(stateOptions);
  }, [stateOptions]);

  return { stateOptions: stateOptions || [], statesMap };
};
